
import { useKnowledgeBase as useKnowledgeBaseHook } from '@/hooks/useKnowledgeBase';

export function useKnowledgeBase() {
  return useKnowledgeBaseHook();
}
